import { PortalTypeEnum } from '@/types/closinglock.types';

export const getCurrentPortal = (): PortalTypeEnum => {
    const { hostname } = window.location;

    if (hostname.startsWith('portal.')) {
        return PortalTypeEnum.CLIENT;
    }

    if (hostname.startsWith('employee.')) {
        return PortalTypeEnum.EMPLOYEE;
    }

    return PortalTypeEnum.COMPANY;
};
